import React from 'react';
import {PktButton} from "@oslokommune/punkt-react";
import {PLASS_TILBUD_ROUTE} from '../../../routes';
import {goToUrl} from "../../../utils/utils";
import ApplicationCard from "../../ApplicationCard/ApplicationCard";

type UtgåttTilbudCardProps = {
    barnNavn: string;
    applicationId: number
    svarFrist: string | null;
}

const UtgåttTilbudCard = ({ barnNavn, applicationId, svarFrist }: UtgåttTilbudCardProps) => {
    return (
        <ApplicationCard title={barnNavn} variant={"blå"}>
            <div className={"pkt-txt-16-light"}>
                Du har fått et tilbud om barnehageplass.
                Svarfrist var{' '}
                {svarFrist
                    ? new Date(svarFrist).toLocaleDateString('no', { dateStyle: 'long' })
                    : ''} og det er ikke lenger mulig å svare på tilbudet.{' '}
                <div>
                    <a
                        href={'https://www.oslo.kommune.no/barnehage/kontakt-barnehageadministrasjonen/'}
                        className="pkt-link"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Kontakt Oslo kommunes kontaktsenter for barnehage
                    </a>{' '}
                    hvis du trenger hjelp.
                </div>
            </div>
            <PktButton
                onClick={() => goToUrl(`${PLASS_TILBUD_ROUTE}/${applicationId}`)}
                size={"small"}
                className={"mt-size-16"}
            >
                Se tilbudet
            </PktButton>
        </ApplicationCard>
    );
};

export default UtgåttTilbudCard;